import { LinkText } from '@components/LinkText';
import { DataTable } from '@components/Table/DataTable';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import IFatura, { useFaturaTipoColor } from '@model/Fatura';
import { useFaturaStatusColor } from '@model/FaturaStatus';
import React from 'react';

export type FichaVendedorInadimplentesTableProps = {
    data: IData<IFatura>
    isLoading: boolean
}

export function FichaVendedorInadimplentesTable ({ data, isLoading }: FichaVendedorInadimplentesTableProps) {
    const formatter = useFormatter();
    const faturaStatusColor = useFaturaStatusColor();
    const faturaTipoColor = useFaturaTipoColor();

    return (
        <DataTable 
            isLoading={isLoading} 
            itemCount={data.itemsCount}
        >
            <TableHead>
                <TableRow>
                    <TableHeaderCell>ID</TableHeaderCell>
                    <TableHeaderCell>Cliente</TableHeaderCell>
                    <TableHeaderCell>Empresa</TableHeaderCell>
                    <TableHeaderCell>Vencimento</TableHeaderCell>
                    <TableHeaderCell>Vlr. Total</TableHeaderCell>
                    <TableHeaderCell>Vlr. Pago</TableHeaderCell>
                    <TableHeaderCell>Saldo</TableHeaderCell>
                    <TableHeaderCell>Pagamento</TableHeaderCell>
                    <TableHeaderCell>Forma Pgto.</TableHeaderCell>
                    <TableHeaderCell>Tipo</TableHeaderCell>
                    <TableHeaderCell>Status</TableHeaderCell>
                </TableRow>
            </TableHead>
            
            <TableBody>
                {
                    data.items.map((fatura, index) => {
                        return (
                            <TableRow key={index}>
                                <TableKeyCell>{fatura.faturaId}</TableKeyCell>
                                <TableCell><LinkText to={`/cliente/${fatura.clienteId}`} text={fatura.clienteNome} /></TableCell>
                                <TableCell>{fatura.empresaNome}</TableCell>
                                <TableCell>{formatter.toDate(fatura.dataVencimento)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.valorTotal)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.valorPago)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.saldo)}</TableCell>
                                <TableCell>{formatter.toDate(fatura.dataPagamento)}</TableCell>
                                <TableCell>{fatura.formaPagamentoNome}</TableCell>
                                
                                <TableCell className={faturaTipoColor[fatura.tipo]}>
                                    { fatura.tipo }
                                </TableCell>

                                <TableCell 
                                    className={faturaStatusColor[fatura.faturaStatusId]}
                                >
                                    { fatura.faturaStatusNome }
                                </TableCell>
                           </TableRow>
                        )
                    })
                }
            </TableBody>
        </DataTable>
    )
}